export const componentDnDDataTransfer = {
    type: "componentData:type",
    name: "componentData:name",
    componentId: "componentData:componentId"
};
